<template>
	<div class="mg-slide">
		<div v-if="imageUri" class="slide-image-container">
			<video
				v-if="isVideo"
				ref="videoElement"
				:src="imageUri"
				muted
				:loop="videoLoop"
				playsinline
				class="slide-image"
				:class="`${variant}-variant`"
			></video>
			<img
				v-else
				:src="imageUri"
				alt=""
				class="slide-image"
				:class="`${variant}-variant`"
			/>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MGSheetSlide',
	props: {
		imageUri: {
			type: String,
			default: null
		},
		imageHeight: {
			type: String,
			default: '220'
		},
		videoLoop: {
			type: Boolean,
			default: false
		},
		variant: {
			type: String,
			default: 'sheet'
		}
	},
	computed: {
		isTruelayer() {
			return this.actionUri && this.actionUri.toLowerCase().includes('truelayer');
		},
		isVideo() {
			if (!this.imageUri) return false;
			const videoExtensions = ['.mp4', '.webm', '.mov', '.avi'];
			return videoExtensions.some(ext =>
				this.imageUri.toLowerCase().endsWith(ext)
			);
		}
	},
	methods: {
		playVideo() {
			const video = this.$refs.videoElement;
			if (video) {
				const playPromise = video.play();
				if (playPromise !== undefined) {
					playPromise.catch(error => {
						// Handle autoplay interruption errors
						// This can occur when browsers pause video-only background media to save power
						// or when autoplay policies prevent playback
						if (error.name === 'AbortError') {
							console.debug('Video autoplay was interrupted by the browser for power saving');
						} else if (error.name === 'NotAllowedError') {
							console.debug('Video autoplay was blocked by browser autoplay policy');
						}
					});
				}
			}
		}
	},
	watch: {
		imageUri() {
			this.$nextTick(() => {
				this.playVideo();
			});
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.playVideo();
		});
	}
}
</script>

<style scoped>
.mg-slide {
	display: flex;
	flex-direction: column;
	height: 100%;
	min-height: 0;
}

.slide-image-container {
	flex: 0 1 auto;
	min-height: 0;
	width: 100%;
	margin-top: 8px;
	display: flex;
	justify-content: center;
}

/* Variant-specific image constraints */
.slide-image-container:has(.sheet-variant) {
	max-height: 50%;
}

.slide-image-container:has(.story-variant) {
	max-height: 65%;
}

.slide-image {
	height: v-bind("imageHeight + 'px'");
	border-radius: 12px;
	object-fit: cover;
}

/* Small screens */
@media (max-height: 700px) {
	.slide-image-container:has(.sheet-variant) {
		max-height: 45%;
	}

	.sheet-variant {
		height: 130px;
	}

	.story-variant {
		height: 220px;
	}

	.slide-image-container {
		margin-bottom: 12px;
		margin-top: 4px;
	}
}
</style>
